// ================================================================
// File pendukung Shipping Manifest — unggah & buka.
// ================================================================
// Sejak 2026-08-03 file diunggah ke service `file_upload` (volume Docker
// `uploaded_files`), sama seperti lampiran MSR/procurement, bukan lagi ditulis
// backend ke folder ./data/pdf lewat /uploadShippingManifest.
//
// Kolom TShippingManifest."SupportingFile" hanya menyimpan NAMA file, tanpa
// penanda lokasi, jadi dokumen lama tidak bisa dibedakan dari namanya. Karena
// itu saat membuka: coba service file dulu, kalau 404 baru jatuh ke jalur lama
// (/pdfGeneral). Dengan begitu manifest lama tetap bisa dibuka tanpa migrasi
// file.
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

import { fetchPostMultipartSeaweed } from "../../../fetchers";

const uploadBase = () => process.env.REACT_APP_API_UPLOAD_URL || "/";

// Nama unik: prefix UUID seperti lampiran MSR supaya dua unggahan dengan nama
// asli sama tidak saling menimpa; JrID disisipkan agar file mudah dilacak.
export const namaFilePendukung = (jrID, file) =>
  `${uuidv4()}-${String(jrID).replaceAll("/", "-")}-${file.name.replaceAll(" ", "_")}`;

// Unggah ke service file. Mengembalikan nama file untuk disimpan di kolom
// SupportingFile.
export async function uploadSupportingFile(jrID, file) {
  const nama = namaFilePendukung(jrID, file);
  const fd = new FormData();
  fd.append("file", file, nama);
  await fetchPostMultipartSeaweed(fd);
  return nama;
}

async function ambilBlob(url, headers) {
  const res = await fetch(url, { method: "GET", headers });
  if (!res.ok) return null;
  const blob = await res.blob();
  return blob.size > 0 ? blob : null;
}

export async function openSupportingFile(nama) {
  if (!nama) return;
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  try {
    let blob = await ambilBlob(
      uploadBase() + "file/" + encodeURIComponent(nama),
      { Accept: "*/*" }
    );
    if (!blob) {
      // Jalur lama: backend melayani ./data/pdf, dan id memakai konvensi dash.
      blob = await ambilBlob(
        process.env.REACT_APP_API_URL + "pdfGeneral?id=" + String(nama).replaceAll("/", "-"),
        { Accept: "*/*", Authorization: "Bearer " + user?.Token }
      );
    }
    if (!blob) { toast.error("File pendukung tidak ditemukan"); return; }
    window.open(window.URL.createObjectURL(blob));
  } catch (e) {
    toast.error("Gagal membuka file pendukung");
  }
}
